import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { isEmpty } from 'lodash';
import styles from './Login.module.scss';
import { useFetch } from 'hooks/useFetch';
import { usePost } from 'hooks/usePost';
import { authenticationEndpoints } from 'hooks/endpoints';
import { useToast } from 'app-context/toasterContext/ToastContext';
import Button from 'component/atom/forms/button/Button';
import Input from 'component/atom/forms/input/input/Input';
import logo from '../../../assets/image/AIDucator-Logo.svg';
import ErrorMobile from '../../../assets/image/error-mobile.svg';
const validationSchema = yup.object({
  username: yup.string().required('Username is required'),
  password: yup
    .string()
    .min(6, 'Password must be at least 6 characters')
    .max(20, 'Password can be at most 20 characters')
    .required('Password is required'),
});
const LoginForm = ({ data }) => {
  const { mutate: login, isPending } = usePost({
    onErrorToast: 'Invalid Credentials',
  });
  const customizedToast = useToast();
  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  const handleSubmit = async (data) => {
    const fields = { username: data.username, password: data.password };
    login(
      {
        url: authenticationEndpoints.login(),
        data: fields,
        requireAuth: false,
      },
      {
        onSuccess: async (data) => {
          localStorage.setItem('token', JSON.stringify(data.data.token));
          localStorage.setItem('AIDucator_userId', data.data.userId);

          const token = localStorage.getItem('token');
          const userId = localStorage.getItem('AIDucator_userId');

          if (token && userId) {
            window.location.reload();
          } else {
            customizedToast.open({
              message: 'Login failed. Please try again.',
              type: 'error',
            });
          }
        },

        onError: (error) => {},
      }
    );
  };
  return (
    <form className={styles['login-bg']} onSubmit={formik.handleSubmit}>
      <div className={styles['login-page-wrapper']}>
        {!isEmpty(data?.data[0]?.sideBarLogo) ? (
          <img
            src={`data:${data?.data[0]?.sideBarLogoContentType};base64,${data?.data[0]?.sideBarLogo}`}
            className={styles['logo']}
          />
        ) : (
          <img className={styles['logo']} src={logo} />
        )}
        <div
          className={styles['login-card']}
          style={{ backgroundColor: data?.data[0]?.loginBackgroundColor }}
        >
          <Input
            label="username"
            value={formik.values.username}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="username"
            error={formik.errors.username}
            touched={formik.touched.username}
          />
          <Input
            label="Password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="password"
            error={formik.errors.password}
            touched={formik.touched.password}
            inputType="password"
          />
          <Button
            label="Login"
            isLoading={isPending}
            onClick={formik.handleSubmit}
            width="100%"
            variant="primary"
            buttonType="submit"
          />
        </div>
      </div>
    </form>
  );
};
function Login() {
  const [url, setUrl] = useState('');
  const { data: data } = useFetch(
    ['loginData', url],
    authenticationEndpoints.getLoginDataBySubDomain(url),
    {
      enabled: process.env.NODE_ENV === 'production' ?? false,
    }
  );

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      setUrl('aiducatorfe');
    } else {
      const currentURL = window.location.href;
      const match = currentURL.match(/\/\/([^/.]+)\./);
      if (match && match.length > 1) {
        const extractedPart = match[1];
        setUrl(extractedPart);
      } else {
        setUrl('');
      }
    }
  }, []);

  return (
    <>
      <div className={styles['login-container']}>
        <LoginForm data={data} />
      </div>
      <div className={styles['mobile-layout']}>
        <img
          src={ErrorMobile}
          alt="Mobile Error"
          className={styles['error-mobile-img']}
        />
        <div className={styles['error-mobile-text']}>
          <span className={styles['error-mobile-title']}>
            Mobile not supported
          </span>
          <span className={styles['error-mobile-sub']}>
            For the full AiDucator experience, please transfer to desktop to
            continue work.
          </span>
        </div>
      </div>
    </>
  );
}

export default Login;
